/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AutoSelectSubjectIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Auto Select Subject',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m10,12.00293c-1.90918,0-3.46289-1.62891-3.46289-3.63184s1.55371-3.63184,3.46289-3.63184,3.46289,1.62891,3.46289,3.63184-1.55371,3.63184-3.46289,3.63184Zm0-5.76367c-1.08203,0-1.96289.95605-1.96289,2.13184s.88086,2.13184,1.96289,2.13184,1.96289-.95605,1.96289-2.13184-.88086-2.13184-1.96289-2.13184Z"
      fill="currentColor"
    />
    <path
      d="m14.91602,18.67871c-.41406,0-.75-.33594-.75-.75,0-2.81055-2.61035-3.23047-4.16602-3.23047-1.25293,0-4.16602.31445-4.16602,3.23047,0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75c0-2.91797,2.1709-4.73047,5.66602-4.73047s5.66602,1.8125,5.66602,4.73047c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m18,18.74707c-.41406,0-.75-.33594-.75-.75,0-.2041-.00586-.40039-.01465-.58887-.02051-.41309.29883-.76465.71289-.78516.38574-.02832.76562.29883.78516.71289.01074.21191.0166.43164.0166.66113,0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m10.6123,1.55664c-.4375-.04492-.89551-.04395-1.32324-.00488-.41309.03711-.71777.40137-.68066.81348.03711.41309.39941.70801.81348.68066.33887-.03027.69922-.02832,1.0459.00293.02441.00293.04883.00391.07324.00391.38184,0,.70801-.29004.74512-.67773.04004-.41211-.26172-.7793-.67383-.81836Z"
      fill="currentColor"
    />
    <path
      d="m4.53027,9.76465c-.3623.2002-.49414.65625-.29492,1.01953.11133.20215.23047.43262.22656.67285-.04883.41113.24414.78418.65527.83398.03125.00293.06055.00488.09082.00488.37402,0,.69824-.2793.74414-.66113.00879-.07812.01367-.15625.01367-.2334,0-.51465-.2002-.94922-.41602-1.3418-.2002-.3623-.65527-.49414-1.01953-.29492Z"
      fill="currentColor"
    />
    <path
      d="m2.7334,12.9834c-.3252.3252-.60059.72461-.81641,1.18555-.17578.375-.01465.82129.36035.99707.10254.04883.21094.07129.31738.07129.28223,0,.55273-.15918.67969-.43164.14258-.30273.31738-.55957.51953-.76172.29297-.29297.29297-.76758,0-1.06055s-.76758-.29297-1.06055,0Z"
      fill="currentColor"
    />
    <path
      d="m6.27637,2.65625c-.35742.25586-.69531.55664-1.00293.89453-.27832.30566-.25684.78027.0498,1.05957.14355.13086.32422.19531.50488.19531.20312,0,.40625-.08203.55469-.24512.23633-.25879.49414-.48926.7666-.68359.33691-.24121.41406-.70898.17383-1.04688-.24023-.33496-.70703-.41602-1.04688-.17383Z"
      fill="currentColor"
    />
    <path
      d="m2,18.67871c-.41406,0-.75-.33594-.75-.75,0-.22754.00488-.44727.01367-.65527.01562-.41504.40137-.74023.77832-.71973.41406.01562.73633.36426.71973.77832-.00684.19043-.01172.38867-.01172.59668,0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m17.36133,15.35547c-.28223,0-.55176-.15918-.67969-.43066-.14746-.3125-.3252-.59375-.52832-.83398-.26758-.31641-.22852-.78906.08789-1.05664.31543-.2666.78809-.22949,1.05664.08789.28809.34082.53809.73242.74121,1.16406.17676.37402.01562.82129-.35938.99805-.10254.04883-.21191.07129-.31836.07129Z"
      fill="currentColor"
    />
    <path
      d="m14.92676,12.27051c-.41406,0-.75-.31738-.75-.73145v-.03711c0-.5166.17188-.97949.28516-1.28613.14355-.38574.58789-.62598.97754-.48535.3877.14258.60352.5293.46191.91797-.11816.31934-.22461.60547-.22461.85352,0,.41406-.33594.76855-.75.76855Z"
      fill="currentColor"
    />
    <path
      d="m15.66602,8.34082c-.41309,0-.74902-.33496-.75-.74805-.00098-.36816-.03711-.70801-.10742-1.01074-.09375-.40332.15723-.80664.56055-.90039.39746-.09766.80566.15625.90039.56055.0957.41211.14551.86523.14648,1.34668.00098.41406-.33398.75098-.74805.75195h-.00195Z"
      fill="currentColor"
    />
    <path
      d="m4.33203,8.34082c-.41406-.00098-.74902-.33789-.74805-.75195.00098-.48145.05078-.93457.14648-1.34668.09473-.4043.50293-.6582.90039-.56055.40332.09375.6543.49707.56055.90039-.07031.30273-.10645.64258-.10742,1.01074-.00098.41309-.33691.74805-.75.74805h-.00195Z"
      fill="currentColor"
    />
    <path
      d="m14.12305,4.72754c-.19336,0-.38672-.07422-.5332-.22266-.24121-.24414-.50879-.46289-.7959-.65137-.3457-.22754-.44238-.69336-.21484-1.03906.22852-.3457.69336-.44043,1.03906-.21484.37402.24609.72363.53223,1.03809.85059.29102.29395.28906.76953-.00586,1.06055-.14551.14453-.33691.2168-.52734.2168Z"
      fill="currentColor"
    />
  </svg>`;
};
